import { DatePicker, forwardRef } from '@heroui/react'
import {
  getLocalTimeZone,
  now,
  parseAbsolute,
  toZoned,
} from '@internationalized/date'
import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'

const StartTimeInput = forwardRef(({ onChange, value, ...props }, ref) => {
  const selectedTimezone = useWatch({
    name: 'timezone',
  })

  const activeTimezone = useMemo(() => {
    return selectedTimezone ?? getLocalTimeZone()
  }, [selectedTimezone])

  const dateValue = useMemo(() => {
    if (!value)
      return null

    return parseAbsolute(value, activeTimezone)
  }, [value, activeTimezone])
  const handleChange = (date) => {
    if (!date) {
      onChange(null)
      return
    }

    const zonedDate = toZoned(date, activeTimezone)
    const formattedString = zonedDate.toAbsoluteString()
    onChange(formattedString)
  }

  return (
    <DatePicker
      ref={ref}
      showMonthAndYearPickers
      granularity="minute"
      variant="bordered"
      radius="sm"
      labelPlacement="outside"
      name="start_time"
      label="Start Time"
      description="The time you want the call to start. If you don't specify a time, the call will send immediately."
      {...props}
      value={dateValue}
      onChange={handleChange}
      minValue={now(activeTimezone)}
    />
  )
})

export default StartTimeInput
